<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
        <span>Regra Padrão</span>
    </div>

    @if (pendente) {
    <app-alert-card type="error" title="Regra tributária obrigatória" icon="error">
        Com a Reforma Tributária ativa é obrigatório vincular uma regra tributária na regra
        padrão. Vincule uma regra ou desative a Reforma Tributária para salvar.
    </app-alert-card>
    }

    @if (!regra) {
    <div class="regra-empty">
        <mat-icon class="material-symbols-outlined empty-icon">link_off</mat-icon>
        <p class="empty-titulo">Nenhuma regra tributária vinculada</p>
        <p class="empty-subtitulo">
            Selecione uma regra já cadastrada ou cadastre uma nova no fluxo de
            Regras Tributárias.
        </p>
        <div class="regra-empty-actions">
            <button mat-flat-button class="btn-primary" type="button" (click)="selecionarRegra.emit()">
                <mat-icon class="material-symbols-outlined">checklist</mat-icon>
                Selecionar regra
            </button>
            <button mat-stroked-button class="btn-secondary" type="button" (click)="cadastrarRegra.emit()">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
                Cadastrar nova regra
            </button>
        </div>
    </div>
    } @else {
    <div class="regra-card">
        <div class="regra-card-main">
            <div class="regra-card-title">
                <span>{{ regra.nome }}</span>
            </div>
            <p class="mb-1"><strong>CST IBS/CBS:</strong> <span class="status-badge badge-azul ms-1">{{ regra.cst }}</span></p>
            <p class="mb-1"><strong>Cód. Classificação Trib. IBS/CBS:</strong> <span class="status-badge badge-roxo ms-1">{{ regra.cclassTrib }}</span></p>
            <p class="mb-0 d-flex flex-wrap gap-1 align-items-center">
                <strong class="me-1">Modelos de Documento:</strong>
                @for (modelo of regra.modelosDocumento; track $index) {
                    <span class="status-badge badge-cinza">{{ nomeModeloPorCodigo[modelo] ?? modelo }}</span>
                }
                @if (regra.modelosDocumento.length === 0) {
                    <span class="text-secondary">—</span>
                }
            </p>
        </div>
        <div class="regra-card-footer">
            <div class="regra-card-footer-left">
                <button mat-flat-button class="btn-primary" type="button" (click)="selecionarRegra.emit()">
                    <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
                    Trocar regra
                </button>
                <button mat-stroked-button class="btn-secondary" type="button" (click)="editarRegra.emit(regra)">
                    <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
                    Editar no cadastro
                </button>
            </div>
            <button mat-stroked-button class="btn-secondary btn-desvincular" type="button" (click)="removerRegra.emit()">
                <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                Desvincular
            </button>
        </div>
    </div>
    }
</div>
